import { useState } from "react";
import "./index.scss";
import logo from "@/assets/img/logo.png";
import SelectBar from "../select";
import useData from "../../useData";
import { enumAddressName } from "../../../../constants";
import { useContextData } from "../../data-context";
import juweiIcon from "@/assets/img/juwei.svg";
interface IProps {
  selectOptions: any[];
  tab: number;
  setTab: (v: number) => void;
}

const Header = (props: IProps) => {
  const { setTab, tab, selectOptions } = props;
  const { contextData: { selectAddress }, setContextData } = useContextData();

  const first = useData(enumAddressName[1]);
  const second = useData(enumAddressName[2]);
  const third = useData(enumAddressName[3]);
  const fourth = useData(enumAddressName[4]);
  const fifth = useData(enumAddressName[5]);
  const sixth = useData(enumAddressName[6]);

  return (
    <div className="header">
      <img src={logo} className="logo" alt="" />
      <div className="divider"></div>
      <SelectBar
        value={selectAddress?.name}
        selectOptions={selectOptions}
        onSelect={(data) => {
          setContextData({ selectAddress: data });
        }}
      />
      <div className="tabs">
        <div className="tab" onClick={() => setTab(1)}>
          <i
            className={`iconfont icon-zhengfu ${
              tab === 1 ? "activeIcon1" : ""
            }`}
          ></i>
          <div className={`tab-text ${tab === 1 ? "activeTab1" : ""}`}>
            镇级体育场所
          </div>
          {!!first.length && <div className="number">{first.length}</div>}
        </div>
        <div className="tab" onClick={() => setTab(2)}>
          <i
            className={`iconfont icon-gonggong ${
              tab === 2 ? "activeIcon2" : ""
            }`}
          ></i>
          <div className={`tab-text ${tab === 2 ? "activeTab2" : ""}`}>
            公共体育场所
          </div>
          {!!second.length && <div className="number">{second.length}</div>}
        </div>
        <div className="tab" onClick={() => setTab(3)}>
          <i
            className={`iconfont icon-yuanqu ${tab === 3 ? "activeIcon3" : ""}`}
          ></i>
          <div className={`tab-text ${tab === 3 ? "activeTab3" : ""}`}>
            园区体育场所
          </div>
          {!!third.length && <div className="number">{third.length}</div>}
        </div>
        <div className="tab" onClick={() => setTab(4)}>
          <i
            className={`iconfont icon-shangquan ${
              tab === 4 ? "activeIcon4" : ""
            }`}
          ></i>
          <div className={`tab-text ${tab === 4 ? "activeTab4" : ""}`}>
            商圈体育场所
          </div>
          {!!fourth.length && <div className="number">{fourth.length}</div>}
        </div>
        <div className="tab" onClick={() => setTab(5)}>
          <i
            className={`iconfont ${
              tab === 5 ? "icon-juwei-active" : "icon-juwei"
            }`}
          ></i>
          <div className={`tab-text ${tab === 5 ? "activeTab5" : ""}`}>
            居委综合活动室
          </div>
          {!!fifth.length && <div className="number">{fifth.length}</div>}
        </div>
        <div className="tab" onClick={() => setTab(6)}>
          <i
            className={`iconfont icon-xuexiao ${
              tab === 6 ? "activeIcon6" : ""
            }`}
          ></i>
          <div className={`tab-text ${tab === 6 ? "activeTab6" : ""}`}>
            学校体育场所
          </div>
          {!!sixth.length && <div className="number">{sixth.length}</div>}
        </div>
      </div>
    </div>
  );
};

export default Header;
